import { Link } from 'react-router-dom'

const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>一般社団法人 日本ITビジネス・プロフェッショナル協会</h3>
            <p>Japan Institute of IT Business Professionals (JITBP)</p>
            <p>未来へ、次の挑戦へ。</p>
          </div>
          <div className="footer-section">
            <h4>組織情報</h4>
            <ul>
              <li>
                <a href="#about" onClick={() => scrollToSection('about')}>
                  組織概要
                </a>
              </li>
              <li>
                <a href="#services" onClick={() => scrollToSection('services')}>
                  事業内容
                </a>
              </li>
              <li>
                <Link to="/board">理事紹介</Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>会員・お知らせ</h4>
            <ul>
              <li>
                <a href="#membership" onClick={() => scrollToSection('membership')}>
                  会員募集
                </a>
              </li>
              <li>
                <a href="#news" onClick={() => scrollToSection('news')}>
                  最新情報
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>お問い合わせ</h4>
            <ul>
              <li>
                <Link to="/contact">お問い合わせ</Link>
              </li>
              <li>
                <Link to="/privacy-policy">プライバシーポリシー</Link>
              </li>
              <li>
                <Link to="/site-policy">サイトポリシー</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2025 一般社団法人 日本ITビジネス・プロフェッショナル協会（JITBP） All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer

